import __base_store from '@/store/__base_store'

/**
 * Store de artículos pre-importados (modelo `articles_pre_import`).
 * Construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'articles_pre_import',
	},
})

